import { valibotResolver } from '@hookform/resolvers/valibot';
import { array, nonEmpty, nullable, number, object, pipe, string, trim } from 'valibot';

import type { IEquipmentLink } from '@pages/SensorsList/model/equipmentLink';
import type { IFile } from '@model/file';

export const EDIT_EQUIPMENT_NOTES_FIELDS = {
  NAME: 'name',
  DESCRIPTION: 'description',
  LINKS: 'links',
  FILES: 'files',
};

export const emptyItem = {
  name: null,
  link: null,
};

export const schemaEditEquipmentNotes = () =>
  valibotResolver(
    object({
      [EDIT_EQUIPMENT_NOTES_FIELDS.NAME]: pipe(string(), nonEmpty('This field is required.')),
      [EDIT_EQUIPMENT_NOTES_FIELDS.DESCRIPTION]: pipe(string(), trim()),
      [EDIT_EQUIPMENT_NOTES_FIELDS.LINKS]: array(
        object({ name: nullable(string()), link: nullable(string()) }),
      ),
      [EDIT_EQUIPMENT_NOTES_FIELDS.FILES]: nullable(
        array(object({ extension: string(), name: string(), size: number(), url: string() })),
      ),
    }),
  );

export const editEquipmentNotesDefaultValue = (
  name: string,
  description: string | null,
  links: IEquipmentLink[] | null,
  files: IFile[] | null,
) => ({
  [EDIT_EQUIPMENT_NOTES_FIELDS.NAME]: name,
  [EDIT_EQUIPMENT_NOTES_FIELDS.DESCRIPTION]: description || '',
  [EDIT_EQUIPMENT_NOTES_FIELDS.LINKS]: links?.length ? links : [emptyItem],
  [EDIT_EQUIPMENT_NOTES_FIELDS.FILES]: files?.length ? files : [],
});
